module.exports = __webpack_public_path__ + "static/media/bin_icon.967b5562.svg";